// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    message: {
        id: 'error-boundary.message',
        defaultMessage: 'An error has occurred and the Hive team has been notified.'
    },
    buttonLabel: {
        id: 'error-bounary.button-label',
        defaultMessage: 'Please press Refresh to reload the app.'
    },
    buttonText: {
        id: 'error-boundary.button-text',
        defaultMessage: 'Refresh'
    }
});



// WEBPACK FOOTER //
// ./src/components/error-boundary/intl.js